import React from 'react';

import TagDisplay, {
  OPPORTUNITY_STATUS_STYLES,
} from '@totem/components/ui_components/widgets/tagDisplay/tagDisplay';

// Stored status values shown under a different name. "Savings Booked" stays the stored value; users see "realized".
const STATUS_DISPLAY: Record<string, string> = {
  'Savings Booked': 'Savings Realized',
};

type Props = {
  status: string;
};

const OptimizeStatus = ({ status }: Props) => {
  if (!status) {
    return null;
  }

  return (
    <TagDisplay
      value={status}
      label={STATUS_DISPLAY[status]}
      config={OPPORTUNITY_STATUS_STYLES}
    />
  );
};

export default OptimizeStatus;
